/**
 * Created by rathompson on 6/27/22
 * File: InstanceReducer.actions
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

export const SET_INSTANCES = 'SET_INSTANCES'

export const setInstances = (instances = []) => ({
  type: SET_INSTANCES,
  instances
})
